export const DICTIONARY_API_TRANSLATIONS_CONTROLLER_END_POINTS = {
  CONTROLLER_PATH: "translations",
};
